module.exports = __webpack_public_path__ + "img/file.1e48f1c5.png";